import React, { useEffect, useState } from "react";
import { array, bool, func, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import More from "../../atoms/More";
import LeftImageRightNews from "../../molecules/LeftImageRightNews";
import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";

import { staticTexts } from "../../utils/Translate";
import { getSlotId } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./stories2AdWithLoadMore.m.css";

const TransparentOverlay = () => {
  return <div styleName="transparent-overlay"></div>;
};

const Stories2AdWithLoadMore = ({
  pageType,
  list,
  onLoadMore = null,
  isMoreStories = false,
  loading = false,
  lang,
  sideAd = lang === "en"
    ? pageType === "section-page"
      ? "EnPalo_ROS_300x250_R2"
      : "EnPalo_ROS_336x280_R1"
    : pageType === "section-page"
    ? "News_336x280_R2"
    : "News_336x280_R1",
  midAd = lang === "en"
    ? pageType === "section-page"
      ? "EnPalo_ROS_336x280_R3"
      : "EnPalo_ROS_300x250_R2"
    : pageType === "section-page"
    ? "News_336x280_R3"
    : "News_336x280_R2",
  moreAd = lang === "en" ? "EnPalo_ROS_336x280_R3" : "News_336x280_R3",
}) => {
  const [midAds, setMidAds] = useState();
  const [sideAds, setSideAds] = useState();
  const [showButtonSpinner, setButtonSpinner] = useState(false);
  const { desktop } = useDevice();

  useEffect(() => {
    if (!loading) {
      setButtonSpinner(false);
    }
  }, [loading]);

  useEffect(() => {
    if (global.isMobile) {
      if (pageType === "section-page") {
        midAd = lang === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2";
        sideAd = moreAd;
      } else if (pageType !== "section-page") {
        midAd = lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1";
        sideAd = lang === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2";
      }
    }

    setMidAds(midAd);
    setSideAds(sideAd);
  }, []);

  if (!(list && list.length)) {
    return null;
  }
  const storyList = [...list];

  const handleButtonClick = (e) => {
    setButtonSpinner(true);
    onLoadMore(e);
  };

  const MoreComponent = (
    <div styleName="load-more-view">
      <More
        type="load-more"
        text={staticTexts(lang).more}
        onClick={handleButtonClick}
        showButtonSpinner={showButtonSpinner}
      />
    </div>
  );

  return (
    <>
      {showButtonSpinner && <TransparentOverlay />}
      <div styleName="wrapper" className="two-stories-with-load-more-wrapper">
        {desktop && <div styleName="space-hide-mobile" className="space-hide-mobile" />}
        <div className="stories-set" styleName="stories_set">
          {storyList.map((story, index) => (
            <React.Fragment key={index}>
              {midAds && index !== 0 && (index % 10 === 5 || index === 5) && (
                <DfpContainer>
                  <div styleName="ad-wrapper" className="adsBox">
                    <div styleName="ad-slot">
                      <DfpComponent
                        type={index === 5 ? midAds : moreAd}
                        slotId={getSlotId(index === 5 ? midAds : moreAd, "Stories2AdWithLoadMore", index)}
                      />
                    </div>
                  </div>
                </DfpContainer>
              )}
              <LeftImageRightNews story={story} widths={[200, 300, 370]} showExcerpt={global.isDesktop} />
            </React.Fragment>
          ))}

          {isMoreStories ? MoreComponent : null}
        </div>

        <DfpContainer>
          <div styleName="side-ad-wrapper" className="adsBox">
            {sideAds && (
              <div styleName="side-ad" className="side-ad">
                <DfpComponent type={sideAds} slotId={getSlotId(sideAds, "Stories2AdWithLoadMore-side-ad")} />
              </div>
            )}
          </div>
        </DfpContainer>
      </div>
    </>
  );
};

Stories2AdWithLoadMore.propTypes = {
  list: array,
  onLoadMore: func,
  setLoading: func,
  loading: bool,
  isMoreStories: bool,
  lang: string,
  sideAd: string,
  midAd: string,
  moreAd: string,
  pageType: string,
  domainSlug: string,
};

Stories2AdWithLoadMore.storyLimit = 15;

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  pageType: get(state, ["qt", "pageType"], ""),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(Stories2AdWithLoadMore);
